var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-checkbox-group",class:{
  'fm-checkbox-group-vertical': this.vertical !== false,
  'fm-checkbox-group-wrap': this.wrap !== false
}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }